export default "/images/ef20386dc713ebf58f7126c4596e991d.avif";